'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ownerState", "slots", "slotProps"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import { useConversationContext } from "./internals/ConversationContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const ConversationSubtitle = /*#__PURE__*/React.forwardRef(function ConversationSubtitle(props, ref) {
  const _ref = props,
    {
      ownerState: ownerStateProp,
      slots,
      slotProps
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  const ownerState = useConversationContext();
  void ownerStateProp;
  const Subtitle = slots?.subtitle ?? 'div';
  const subtitleProps = useSlotProps({
    elementType: Subtitle,
    externalSlotProps: slotProps?.subtitle,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    }
  });
  return /*#__PURE__*/_jsx(Subtitle, _extends({}, subtitleProps, {
    children: ownerState.conversation?.subtitle ?? null
  }));
});
if (process.env.NODE_ENV !== "production") ConversationSubtitle.displayName = "ConversationSubtitle";